import { z } from 'zod';

const cashFlowTypeSchema = z.union([
  z.literal('CustomerPayments'),
  z.literal('SupplierAndEmployeePayments'),
  z.literal('ObtainedInterest'),
  z.literal('InterestExpense'),
  z.literal('PaymentTaxes'),
  z.literal('BusinessAcquisitions'),
  z.literal('IntangibleAssetsAcquisitions'),
  z.literal('IntangibleAssetsSales'),
  z.literal('TangibleAssetsAcquisitions'),
  z.literal('TangibleAssetsSales'),
  z.literal('FinancialAssetsAcquisitions'),
  z.literal('FinancialAssetsDividends'),
  z.literal('FinancialAssetsSales'),
  z.literal('NewLending'),
  z.literal('RepaymentLending'),
  z.literal('Borrowing'),
  z.literal('RepaymentBorrowing'),
  z.literal('NewIssue'),
  z.literal('ShareholdersContribution'),
  z.literal('ShareholderDividend'),
  z.literal('OwnContribution'),
  z.literal('OwnWithdrawal'),
  z.literal('CurrencyAdjustment'),
  z.literal('Unknown'),
]);
type CashFlowType = z.infer<typeof cashFlowTypeSchema>;

// TODO#1730
const cashFlowTypeWithUnknownSchema = cashFlowTypeSchema.or(z.literal('UnknownType'));
type CashFlowTypeWithUnknown = z.infer<typeof cashFlowTypeWithUnknownSchema>;

export {
  cashFlowTypeSchema,
  cashFlowTypeWithUnknownSchema,
  type CashFlowType,
  type CashFlowTypeWithUnknown,
};
